import state from './moduleOrderRequestApprovalState.js';
import mutations from './moduleOrderRequestApprovalMutations.js';
import actions from './moduleOrderRequestApprovalActions.js';
import getters from './moduleOrderRequestApprovalGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
